import { ToastContainer, toast } from "react-toastify";

const Toaster = () => {
  return (
    <ToastContainer
      position="top-left"
      autoClose={3000}
      hideProgressBar={true}
      newestOnTop={false}
      closeOnClick
      rtl={false}
      pauseOnFocusLoss
      draggable
      pauseOnHover
      theme="colored"
      className="toast-container"
    />
  );
};

export const showSuccess = (message) => {
  toast.success(message, {
    className: "toast-message",
  });
};

export const showError = (message) => {
  toast.error(message, {
    className: "toast-message",
  });
};

export const showWarning = (message) => {
  toast.warning(message, {
    className: "toast-message",
  });
};

export const showInfo = (message) => {
  toast.info(message, {
    className: "toast-message",
  });
};

export { Toaster };
export default Toaster;


